<template>
  <div class="dp02 p-3 mt-3">
    <div class="text-center w-100">
      <h2> {{ $t("CreateEditCategory.Header") }}</h2>
    </div>
    <v-multiselect
      ref="multiselect"
      v-model="category"
      label="name"
      track-by="id"
      :options="availableCategories"
      @search-change="setValue"
      @input="
        setCategory(category);
        deactivate();
        $emit('next-step');">
      <template slot="noResult">
        <div
          @click="
            setCategory({ id: null, name: categorySearch });
            deactivate();
            $emit('next-step');">
          {{ $t("common.Add") }}.. {{ categorySearch }}
        </div>
      </template>
    </v-multiselect>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'CreateEditTemplateCategory',
  data() {
    return {
      category: '',
      categorySearch: ''
    };
  },
  computed: {
    availableCategories() {
      return this.getCategories();
    }
  },
  watch: {
    category(val) {
      this.setCategory(val);
    }
  },
  mounted() {
    this.fetchCategories();
    this.category = this.getCategory();
  },
  methods: {
    ...mapActions({ fetchCategories: 'createTemplate/fetchCategories' }),
    ...mapMutations({
      setCategory: 'createTemplate/setCategory'
    }),
    ...mapGetters({
      getCategories: 'createTemplate/getCategories',
      getCategory: 'createTemplate/getCategory'
    }),
    setValue(val) {
      this.categorySearch = val;
    },
    deactivate() {
      this.$refs.multiselect.deactivate();
    }
  }
};
</script>

<style lang="scss" scoped></style>
